import React from 'react';
import styled from 'styled-components';
import { useOnomyHub } from '@onomy/react-hub';
import { EthereumWallet } from '@onomy/wallet';

import { AccentButton } from 'components/UI/Button';
import { responsive } from 'theme/constants';
import logo from '../assets/images/onomy.png';
import rightCursor from '../assets/images/rightCursor.png';
import metamask from '../assets/images/metamask.png';

const Wrapper = styled.div`
  text-align: center;
`;

const StyledHeader = styled.header`
  background-image: linear-gradient(to bottom, #16161f, #06060f);
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  font-size: calc(10px + 2vmin);
  color: white;

  @media screen and (max-width: ${responsive.smartphoneLarge}) {
    background-image: none;
    background-color: ${props => props.theme.colors.bgDarkest};
    overflow: hidden;
  }
`;

const StyledTopPart = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 20vh;
  background-color: ${props => props.theme.colors.bgDarken};
  width: 100%;
  @media screen and (max-width: ${responsive.smartphoneLarge}) {
    background-color: transparent;
  }
`;

const StyledLogo = styled.img`
  width: 64px;
  height: 51.2px;
  margin-bottom: 20px;
`;

const StyledLogoText = styled.span`
  text-align: left;
  font: normal normal bold 28px/21px 'Bebas Neue';
  letter-spacing: 0px;
  color: #e1dfeb;
  opacity: 1;
`;

const StyledMiddlePart = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-family: Poppins;
  margin: 20px 0;
`;

const StyledBottomPart = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const BottomTitleText = styled.span`
  text-align: center;
  font: normal normal medium 16px/30px Poppins;
  font-size: 16px;
  letter-spacing: 0px;
  color: ${props => props.theme.colors.txtPrimary};
`;

const BottomDescriptionText = styled.span`
  font: normal normal normal 12px/20px Poppins;
  letter-spacing: 0px;
  color: ${props => props.theme.colors.txtSecondary};
  width: 300px;
  margin-top: 12px;
`;

const WalletWrapper = styled(AccentButton)`
  width: 385px;
  height: 75px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background-color: ${props => props.theme.colors.bgDarken};
  padding: 24px;
  border-radius: 8px;
  margin-bottom: 16px;

  @media screen and (max-width: ${responsive.smartphoneLarge}) {
    width: 300px;
  }
`;

const StyledModal = styled.div`
  width: 433px;
  height: auto;
  padding: 4px 4px 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${props => props.theme.colors.bgNormal};
  margin: 36px auto;
  border-radius: 8px;
  box-shadow: 0 13px 26px 0 rgba(0, 0, 0, 0.16);

  @media screen and (max-width: ${responsive.smartphoneLarge}) {
    width: 100%;
    padding: 4px;
    background-color: transparent;
    border: none;
    box-shadow: none;
  }
`;

const IconWrapper = styled.div`
  width: 43px;
`;

const WalletIcon = styled.img`
  height: 27px;
`;

const WalletText = styled.span`
  font: normal normal normal 16px/25px 'Poppins';
  line-height: 1.56;
  color: ${props => props.theme.colors.txtPrimary};
`;

const RightIcon = styled.img`
  width: 24px;
`;

const KeplrLink = styled.a`
  margin: 5px auto 0;

  font-size: 12px;
  color: ${props => props.theme.colors.textThirdly};
`;

export function EthereumWalletSelect() {
  // TODO: install links if not available
  const { wallet } = useOnomyHub();

  function connect(ethWal: EthereumWallet) {
    wallet.ethereum.connect(ethWal);
  }

  return (
    <Wrapper>
      <StyledHeader>
        <StyledModal>
          <StyledTopPart>
            <StyledLogo src={logo} alt="logo" />
            <StyledLogoText>ONOMY</StyledLogoText>
          </StyledTopPart>
          <StyledMiddlePart>
            <BottomTitleText>Connect Your Wallet</BottomTitleText>
            <BottomDescriptionText>
              To participate in the Bonding Curve Platform, you must connect your Ethereum wallet.
            </BottomDescriptionText>
          </StyledMiddlePart>
          <StyledBottomPart>
            {wallet.ethereum.wallets.map(ethWal =>
              ethWal.isAvailable() ? (
                <WalletWrapper key={ethWal.getId()} onClick={() => connect(ethWal)}>
                  <IconWrapper>
                    <WalletIcon
                      alt={`${ethWal.getDisplayName()} Icon`}
                      src={metamask} // TODO: make dynamic
                    />
                  </IconWrapper>
                  <WalletText>{ethWal.getDisplayName()}</WalletText>
                  <RightIcon alt="Right Cursor" src={rightCursor} />
                </WalletWrapper>
              ) : (
                <a key={ethWal.getId()} href={ethWal.getInstallUrl()} target="_new">
                  <WalletWrapper>
                    <IconWrapper>
                      <WalletIcon
                        alt={`${ethWal.getDisplayName()} Icon`}
                        src={metamask} // TODO: make dynamic
                      />
                    </IconWrapper>
                    <WalletText>{ethWal.getDisplayName()}</WalletText>
                    <RightIcon alt="Right Cursor" src={rightCursor} />
                  </WalletWrapper>
                </a>
              )
            )}
          </StyledBottomPart>
          {!('keplr' in window) && (
            <KeplrLink href="https://www.keplr.app/" target="_new">
              We recommend installing Keplr Wallet before proceeding
            </KeplrLink>
          )}
        </StyledModal>
      </StyledHeader>
    </Wrapper>
  );
}
